/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Equipment_PickInputs */

const en_us2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one item.`)
};

const pt_br2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um item.`)
};

const es_419_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un elemento.`)
};

const pt_pt2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um item.`)
};

const fr_fr2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis au moins un élément.`)
};

const de_de2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle mindestens ein Gerät.`)
};

const it_it2_onboarding_equipment_pick = /** @type {(inputs: Onboarding_Equipment_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno un elemento.`)
};

/**
* | output |
* | --- |
* | "Pick at least one item." |
*
* @param {Onboarding_Equipment_PickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_equipment_pick = /** @type {((inputs?: Onboarding_Equipment_PickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Equipment_PickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_equipment_pick(inputs)
	if (locale === "es-419") return es_419_onboarding_equipment_pick(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_equipment_pick(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_equipment_pick(inputs)
	if (locale === "de-DE") return de_de2_onboarding_equipment_pick(inputs)
	if (locale === "it-IT") return it_it2_onboarding_equipment_pick(inputs)
	return en_us2_onboarding_equipment_pick(inputs)
});
export { onboarding_equipment_pick as "onboarding.equipment_pick" }